<div class="portal-page-content">
  @if (loading) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  }
  <div [fxHide]="loading">
    <h2 class="mt-1">Messages</h2>
    <mat-form-field
      floatLabel="always"
      class="mat-select-form-field"
      appearance="outline"
    >
      <mat-label>Message</mat-label>
      <mat-select
        (selectionChange)="itemPickerSelected($event.value)"
        [required]="false"
        [(value)]="selectedFilterValue"
        disableOptionCentering
      >
        @for (item of filterItems; track item) {
          <mat-option [value]="item">
            {{ item.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @for (message of dataSource.messages | async; track message) {
      <section class="page-section messages-section">
        <div class="header-row">
          <div class="header-text">
            <div
              class="header-heading-first-line"
              role="button"
              tabindex="0"
              [attr.aria-label]="
                message.subject +
                ', sent ' +
                (message.sentOn | date: 'EEE, MMMM dd, yyyy, hh:mm a')
              "
              (click)="viewMessage(message, $event)"
              (keydown.enter)="viewMessage(message, $event)"
              (keydown.space)="
                viewMessage(message, $event); $event.preventDefault()
              "
            >
              <span class="message-subject">{{ message.subject }}</span>
              <p>{{ message.sentOn | date: 'EEE, MMMM dd, yyyy, hh:mm a' }}</p>
            </div>
            <div class="header-heading-last-line">
              <span>{{ message.email }} - {{ message.messageType }}</span>
            </div>
          </div>
        </div>
      </section>
    }
    <mat-paginator
      [length]="dataSource.rowCount | async"
      [pageSize]="pageSize"
      class="mat-paginator-sticky"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
</div>
